import { HeurePointeeChantierDto } from '../../data-access/http/dto/heure-pointee-chantier.dto'
import { HeurePointeeChantier } from '../../../shared/models/heure-pointee-chantier'

export class HeurePointeeChantierMapper {
  static dtoToModel(heurePointeeChantier: HeurePointeeChantierDto): HeurePointeeChantier {
    if (!heurePointeeChantier) {
      return null
    }
    return {
      codeChantier: heurePointeeChantier.codeChantier,
      periode: heurePointeeChantier.periode,
      realiseTotal: heurePointeeChantier.realiseTotal,
      realiseTotalTaux: heurePointeeChantier.realiseTotalTaux,
      realiseTotalMois: heurePointeeChantier.realiseTotalMois,
      projectionTotal: heurePointeeChantier.projectionTotal,
      realiseLg: heurePointeeChantier.realiseLg,
      realiseLgTaux: heurePointeeChantier.realiseLgTaux,
      realiseLgMois: heurePointeeChantier.realiseLgMois,
      engagementLg: heurePointeeChantier.engagementLg,
      projectionLg: heurePointeeChantier.projectionLg,
      realiseCompagnon: heurePointeeChantier.realiseCompagnon,
      realiseCompagnonMois: heurePointeeChantier.realiseCompagnonMois,
      realiseAutreSalarie: heurePointeeChantier.realiseAutreSalarie,
      realiseAutreSalarieMois: heurePointeeChantier.realiseAutreSalarieMois,
      realiseAutreCas: heurePointeeChantier.realiseAutreCas,
      realiseAutreCasMois: heurePointeeChantier.realiseAutreCasMois,
      realiseSousTraitant: heurePointeeChantier.realiseSousTraitant,
      realiseSousTraitantTaux: heurePointeeChantier.realiseSousTraitantTaux,
      realiseSousTraitantMois: heurePointeeChantier.realiseSousTraitantMois,
      engagementSousTraitant: heurePointeeChantier.engagementSousTraitant,
      projectionSousTraitant: heurePointeeChantier.projectionSousTraitant,
      engagementContractualise: heurePointeeChantier.engagementContractualise,
    }
  }
}
